import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const UserProtectedRoutes = ({ children }) => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.token);
  const accountType = useSelector((state) => state.account?.accountType);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, accountType, navigate]);

  if (isAuthenticated && accountType === "real" ||  accountType=="demo") {
    return <>{children}</>;
  } else {
    navigate("/");
  }

  return null;
};

export default UserProtectedRoutes;
